import { Button } from '@mantine/core'
import { useHover } from '@mantine/hooks'
import { IconExternalLink } from '@tabler/icons-react'
import { Link, LinkProps } from '@tanstack/react-router'

type Props = {
  onClick?: () => void
  children: React.ReactNode
} & LinkProps

export default function LinkButton({ onClick, children, ...linkProps }: Props) {
  const { hovered, ref } = useHover()
  return (
    <Button
      ref={ref}
      component={Link}
      variant="transparent"
      size="compact-sm"
      color="black"
      fw={'normal'}
      pl={0}
      rightSection={<IconExternalLink size={15} />}
      style={hovered ? { textDecoration: 'underline' } : {}}
      onClick={onClick}
      {...linkProps}
    >
      {children}
    </Button>
  )
}
